export module Panes {
    export enum Events {
        RESET_PANES = 'panes:reset',
        HIDE_PANE = 'panes:hidePane',
        CLOSE_MOBILE_PANE = 'closeMobilePane',
        // emit this event to request a pane be toggled
        TOGGLE_PANE = 'togglePane',
        // emit this event to request a pane be shown
        SHOW_PANE = 'showPane',
        ACTIVE_CHANGED = 'panes:activeChanged'
    }

    export enum Ids {
        SOIL_SUMMARY = 'SoilSummary',
        FEATURES = 'Features',
        LAYERS = 'Layers',
        Legend = 'Legend',
        METADATA = 'Metadata',
    }
}